import React from 'react'
import regUserIcon from '../assets/register-user-icon.png'

const styles = `
  .ru-trust {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 14px 6px 6px;
    background: #f7f9fc;
    border: 1.5px solid #e8eef7;
    border-radius: 40px;
    transition: border-color 0.15s, box-shadow 0.15s;
    cursor: default;
    font-family: 'Sora', sans-serif;
  }
  .ru-trust:hover {
    border-color: #d0dff0;
    box-shadow: 0 2px 10px rgba(15,28,46,0.07);
  }

  /* stacked avatar circles */
  .ru-avatars {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  .ru-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid #fff;
    background: #0f1c2e;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: -8px;
    font-size: 10px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
  }
  .ru-avatar:first-child { margin-left: 0; }
  .ru-avatar img { width: 100%; height: 100%; object-fit: cover; }
  .ru-avatar.orange { background: #F97316; }
  .ru-avatar.blue   { background: #378ADD; }
  .ru-avatar.green  { background: #34d399; color: #0f1c2e; }
  .ru-avatar.dark   { background: #0f1c2e; }

  .ru-text {
    display: flex;
    flex-direction: column;
    line-height: 1.25;
  }
  .ru-count {
    font-size: 13px;
    font-weight: 700;
    color: #0f1c2e;
    letter-spacing: -0.3px;
    white-space: nowrap;
  }
  .ru-count span { color: #F97316; }
  .ru-label {
    font-size: 10.5px;
    color: #9aaabb;
    font-weight: 400;
    white-space: nowrap;
  }

  /* live dot */
  .ru-live {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #34d399;
    flex-shrink: 0;
    animation: ru-pulse 1.8s ease infinite;
  }
  @keyframes ru-pulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(52,211,153,0.5); }
    50%       { box-shadow: 0 0 0 4px rgba(52,211,153,0); }
  }
`;

const AVATARS = [
  { cls: 'orange', letter: 'A' },
  { cls: 'blue',   letter: 'R' },
  { cls: 'green',  letter: 'S' },
  { cls: 'dark',   letter: 'M' },
];

export default function RegisterUser() {
  return (
    <>
      <style>{styles}</style>
      <div className="ru-trust" title="Trusted by 10L+ clients nationwide">
        {/* Stacked avatars */}
        <div className="ru-avatars">
          {AVATARS.map((a, i) => (
            <div key={i} className={`ru-avatar ${a.cls}`}>
              {a.letter}
            </div>
          ))}
        </div>

        {/* Text */}
        <div className="ru-text">
          <span className="ru-count"><span>2M+</span> clients</span>
          <span className="ru-label">trusted nationwide</span>
        </div>

        {/* Live dot */}
        <div className="ru-live" title="Active users" />
      </div>
    </>
  )
}